import _ from 'lodash';

import React from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';

import Avatar from 'components/Avatar';

import {Options, Message, EditNoteForm} from './components';

import './styles.css';

const SHOW_MORE_TEXT_CUTTOFF = 180;

class ResolvableNoteBlock extends React.Component<any> {
  state = {
    showMore: false
  };

  archiveNote = () => {
    this.props.archiveNote({noteId: this.props.note.id});
  };

  restoreNote = () => this.props.restoreNote({noteId: this.props.note.id});

  toggleShowMore = () => this.setState({showMore: true});

  seeShowMoreButton = () =>
    !this.state.showMore &&
    this.props.note.text.length > SHOW_MORE_TEXT_CUTTOFF;

  submitEditNoteForm = ({noteText, requiresAction}) =>
    this.props.submitEditNoteForm({
      text: noteText,
      noteId: this.props.note.id,
      requiresAction
    });

  setNoteForEdit = () =>
    this.props.setNoteForEdit({noteId: this.props.note.id});

  unsetNoteForEdit = () => this.props.setNoteForEdit({noteId: null});

  resolveNote = () => this.props.resolveNote({noteId: this.props.note.id});

  render() {
    const {
      note: {
        createdBy: {internalAvatarCropped, avatarCropped, initials, fullName},
        createdAt,
        text,
        archived,
        id,
        canBeEdited,
        needsToBeResolved,
        isResolved,
        requiresAction,
        resolvedAt,
        resolvedBy
      },
      editNoteId,
      addOptions,
      editNote,
      optionsDropdownClassName
    } = this.props;

    const messageText = this.seeShowMoreButton()
      ? text.slice(0, SHOW_MORE_TEXT_CUTTOFF) + '...'
      : text;

    const inEditMode = editNoteId === id;
    const showResolveButton = !inEditMode && needsToBeResolved;
    const resolvedByName = _.get(resolvedBy, 'fullName');

    return (
      <div
        className={classNames('ResolvableNoteBlock colab-row-space-between', {
          inEditMode
        })}>
        <div className="avatar">
          <Avatar
            url={internalAvatarCropped || avatarCropped}
            initials={initials}
          />
        </div>
        {!inEditMode && (
          <React.Fragment>
            <Message
              text={messageText}
              showMoreButton={this.seeShowMoreButton()}
              createdAt={createdAt}
              createdByName={fullName}
              toggleShowMore={this.toggleShowMore}
              showResolveButton={showResolveButton}
              resolveNote={this.resolveNote}
              isResolved={isResolved}
              resolvedAt={resolvedAt}
              resolvedByName={resolvedByName}
            />
            {addOptions && (
              <Options
                archived={archived}
                canBeEdited={canBeEdited}
                archiveNote={this.archiveNote}
                restoreNote={this.restoreNote}
                editNote={this.setNoteForEdit}
                dropdownClassName={optionsDropdownClassName}
              />
            )}
          </React.Fragment>
        )}
        {inEditMode &&
          editNote && (
            <EditNoteForm
              message={text}
              noteId={id}
              requiresAction={requiresAction}
              hideEditNoteForm={this.unsetNoteForEdit}
              submitAction={this.submitEditNoteForm}
              formName={this.props.editFormName}
            />
          )}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const editNoteId = props.editNote && props.editNoteSelector(state);

  return {
    editNoteId
  };
};

export default connect(mapStateToProps)(ResolvableNoteBlock);
